export const gt = (x, y) => Number(x) > Number(y)
